import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

/** 当前用户修改自己的登录密码（POST /admin/updatePassword） */
export function updatePassword(data) {
  return request({
    url: '/admin/updatePassword',
    method: 'post',
    data
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

/** 管理员详情（含 roleList、resourceList、companyIds） */
export function getAdminItem(id) {
  return request({
    url: '/admin/' + id,
    method: 'get'
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}

/** 覆盖设置管理员可见会员数据范围的公司 ID 列表；companyIds 为 null 或 [] 表示不限公司 */
export function updateAdminCompanyScope(data) {
  return request({
    url: '/admin/companyScope/update',
    method: 'post',
    data
  })
}

/** 覆盖设置管理员供应商数据范围（须超级管理员）；allSuppliers=true 为全部，否则按 supplierIds 指定 */
export function updateAdminSupplierScope(data) {
  return request({
    url: '/admin/supplierScope/update',
    method: 'post',
    data
  })
}

/**
 * 某管理员的「兑换积分相关」子能力（GET IntegrationModuleScopeVO，与 /admin/info 的 integrationModuleScope 一致）。
 * 字段：memberRegisterAllowed、giftIntegrationAllowed、giftVerifyCardAllowed、
 * giftReasonCategoriesAllowed（只读，③ GET）、verifyCardAllowed、integrationActivationAllowed 等，见《管理后台-兑换积分相关角色与权限说明》
 * 兼容旧短字段名见 normalizeIntegrationScope
 */
export function getAdminIntegrationModuleScope(adminId) {
  return request({
    url: '/admin/integrationModuleScope',
    method: 'get',
    params: { adminId }
  })
}

/**
 * 保存子能力；body: { adminId, memberRegisterAllowed, giftIntegrationAllowed, giftVerifyCardAllowed, verifyCardAllowed, integrationActivationAllowed }
 */
export function updateAdminIntegrationModuleScope(data) {
  return request({
    url: '/admin/integrationModuleScope/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js